import React from 'react';
import autoBind from 'react-autobind';
import { Drawer, Button, Input, Form } from 'antd';
//
import CustomComponent from '../../../components/CustomComponent';
import CommonLoadingView from '../CommonLoadingView';

// props: app, session, enrolment
export default class CommonStudentShippingInfoDrawer extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      isVisible: false,
      isLoading: false,
      enrolment: null,
      formValues: this._getInitialFormValues(null),
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.isVisible &&
      prevProps.enrolment?.id !== this.props.enrolment?.id
    ) {
      this.setState({
        formValues: this._getInitialFormValues(this.props.enrolment),
      });
    }
  }

  _getInitialFormValues(enrolment) {
    const shipping = enrolment?.materialShippingInfo || {};
    return {
      unit: shipping.unit || '',
      street0: shipping.street0 || '',
      street1: shipping.street1 || '',
      city: shipping.city || '',
      province: shipping.province || '',
      postalCode: shipping.postalCode || '',
    };
  }

  show(enrolment) {
    this.setState({
      isVisible: true,
      enrolment,
      formValues: this._getInitialFormValues(enrolment),
    });
  }

  handleClose() {
    this.setState({
      isVisible: false,
      formValues: this._getInitialFormValues(null),
    });
  }

  handleChange(field, e) {
    const value = e.target.value;
    this.setState(prev => ({
      formValues: {
        ...prev.formValues,
        [field]: value,
      },
    }));
  }

  async handleSubmit() {
    this.setState({ isLoading: true });
    const { formValues, enrolment } = this.state;
    const enrolmentObj = {
      materialShippingInfo: {
        unit: formValues.unit || null,
        street0: formValues.street0 || null,
        street1: formValues.street1 || null,
        city: formValues.city || null,
        province: formValues.province || null,
        postalCode: formValues.postalCode || null,
      },
    };

    const { session, app } = this.props;
    const resp = await app.classroom.sessionEnrolment.updateSessionEnrolment(
      session.id,
      enrolment.userID,
      enrolment.externalID,
      enrolmentObj
    );

    if (resp.statusCode === 200) {
      app.alertController.showSuccessAlert('', 'Shipping info updated successfully!');
      this.setState({ isLoading: false, isVisible: false });
      this.props.reload();
    } else {
      app.alertController.showAPIErrorAlert(null, resp);
      this.setState({ isLoading: false });
    }
  }

  render() {
    const { formValues, enrolment, isVisible, isLoading } = this.state;
    const studentName =
      enrolment?.firstName + ' ' + enrolment?.lastName || 'Student';

    return (
      <Drawer
        placement="right"
        title={`Shipping Info for ${studentName}`}
        width={480}
        onClose={this.handleClose}
        open={isVisible}
        bodyStyle={{ paddingBottom: 20 }}
        footer={this._renderDrawerFooter()}
      >
        <CommonLoadingView isLoading={isLoading} />
        <Form layout="vertical">
          <Form.Item label="Apt/Unit">
            <Input value={formValues.unit} onChange={(e) => this.handleChange('unit', e)} />
          </Form.Item>
          <Form.Item label="Street Address">
            <Input value={formValues.street0} onChange={(e) => this.handleChange('street0', e)} />
          </Form.Item>
          <Form.Item label="Street Address 2">
            <Input value={formValues.street1} onChange={(e) => this.handleChange('street1', e)} />
          </Form.Item>
          <Form.Item label="City">
            <Input value={formValues.city} onChange={(e) => this.handleChange('city', e)} />
          </Form.Item>
          <Form.Item label="Province">
            <Input value={formValues.province} onChange={(e) => this.handleChange('province', e)} />
          </Form.Item>
          <Form.Item label="Postal Code">
            <Input value={formValues.postalCode} onChange={(e) => this.handleChange('postalCode', e)} />
          </Form.Item>
        </Form>
      </Drawer>
    );
  }

  _renderDrawerFooter() {
    return (
      <div style={{ textAlign: 'right' }}>
        <Button onClick={this.handleClose} style={{ marginRight: 8 }}>
          Cancel
        </Button>
        <Button onClick={this.handleSubmit} type="primary">
          Save
        </Button>
      </div>
    );
  }
}